import { useTranslation } from "react-i18next";
import * as yup from "yup";
import { setYupLocale } from "../../../utils/setYupLocale";

function useResponseValidationSchema() {
  const { t } = useTranslation();
  const validationSchema = (() => {
    setYupLocale(t);
    return yup.object().shape({
      dateOfResponse: yup.date().required().nullable(),
      statusCompanyCode: yup.mixed().required(),
      comment: yup.string().trim().required(),
      costEstimateCode: yup.mixed().required(),
      //if useSpecificReminderDate is true, specificReminderDate is required
      specificReminderDate: yup.date().when("useSpecificReminderDate", {
        is: true,
        then: yup.date().required().nullable(),
        otherwise: yup.date().nullable(),
      }),
    });
  })();

  return validationSchema;
}

export default useResponseValidationSchema;
